export enum UgcTab {
  UgcTypeCostume = 1, // 服装设计
  UgcTypeMyROMemory = 4, // 我的RO记忆
  UgcTypePhoto = 5, // 美照分享
}